import {
  BREAKPOINT
} from '../constants';

export function PrimaryNav(){
  // Get the elements
  const triggerElement = document.querySelector('.header-menu__trigger');
  const navElement = document.querySelector('.primary-nav');
  const accordionItems = document.querySelectorAll('.primary-nav .js-accordion-item');
  const desktopVal = BREAKPOINT.desktop;
  const searchTrigger = document.querySelector('.header-search__trigger');
  const searchHeader = document.querySelector('.header-search');
  const headerElement = document.querySelector('.header');

  // Create a MediaQueryList object
  const mediaQuery = window.matchMedia(`screen and (max-width: ${desktopVal - 1}px)`);

  // Check if the media query matches the current viewport
  siteNav();

  window.addEventListener('resize', () => {
    siteNav();
  });

  // Open mobile nav
  function siteNav(){

    setTimeout(restoreNavigation, 200);

    function restoreNavigation(){
      if (mediaQuery.matches){
        const openAccordionItem = document.querySelector('.primary-nav .js-accordion-item.is-open');
        if (openAccordionItem) {
          const body = openAccordionItem.querySelector('.primary-nav .js-accordion-item__body');
          const header = openAccordionItem.querySelector('.primary-nav .js-accordion-item__header');
          const parentDiv = document.querySelector('.parent-nav');
          body.style.height = 'auto';
          body.style.height = `${body.scrollHeight}px`;
          navElement.style.height = 'auto';
          navElement.style.height = `${navElement.scrollHeight}px`;
          triggerElement.classList.add('is-active');
          header.classList.add('is-open');
          document.documentElement.classList.add('has-menu-active');
          parentDiv.classList.add('open');
        }
      } else {
        const openAccordionItem = document.querySelector('.primary-nav .js-accordion-item .js-accordion-item__body.open');
        if (openAccordionItem) {
          const parentItem = openAccordionItem.closest('.primary-nav__item.js-accordion-item');

          if (parentItem) {
            parentItem.classList.add('is-open');
          }
        }
      }
    }

    // Add parent element to Nav
    const primaryNavElement = document.querySelector('.primary-nav');
    const parentDiv = primaryNavElement.parentNode;

    // Check if parent div already exists
    if (!parentDiv.classList.contains('parent-nav')) {
      const newParentDiv = document.createElement('div');
      newParentDiv.classList.add('parent-nav');
      parentDiv.insertBefore(newParentDiv, primaryNavElement);
      newParentDiv.appendChild(primaryNavElement);
    }

    // on search close menu
    const parentNavElement = document.querySelector('.parent-nav');
    searchTrigger.addEventListener('click', () => {
      if (navElement.classList.contains('open')) {
        slideUp(navElement); // Slide up the navElement
        navElement.classList.remove('open'); // Remove the 'open' class
        triggerElement.classList.remove('is-active');
        document.documentElement.classList.remove('has-menu-active');
      }
      parentNavElement.classList.remove('open'); // Remove the 'open' class from parentNavElement
    });

    // Add click event listener to the trigger element
    triggerElement.addEventListener('click', () => {
      // Remove the 'is-active' class from headerMenuTrigger
      if (searchHeader.classList.contains('is-active')) {
        searchHeader.classList.remove('is-active');
        searchTrigger.classList.remove('is-active');
        headerElement.classList.remove('is-search-active');
      }

      // Toggle the "active" class on the nav element
      navElement.classList.toggle('active');

      document.documentElement.classList.toggle('has-menu-active');
      const demoDiv = document.querySelector('.parent-nav');
      demoDiv.classList.toggle('open');

      if (navElement.classList.contains('open')) {
        // If accordion content is open, close it with a smooth transition
        slideUp(navElement);
      } else {
        // If accordion content is closed, open it with a smooth transition
        slideDown(navElement);
      }
    });

    accordionItems.forEach(item => {
      const header = item.querySelector('.primary-nav .js-accordion-item__header');
      const body = item.querySelector('.primary-nav .js-accordion-item__body');

      header.addEventListener('click', event => {
        if (mediaQuery.matches){
          header.classList.toggle('is-open');

          if (body) {
            event.preventDefault();
            // Close other open accordion items
            accordionItems.forEach(otherItem => {
              const otherHeader = otherItem.querySelector('.primary-nav .js-accordion-item__header');
              const otherBody = otherItem.querySelector('.primary-nav .js-accordion-item__body');

              if (otherHeader !== header && otherHeader.classList.contains('is-open')) {
                otherHeader.classList.remove('is-open');
                slideUp(otherBody);
              }
            });

            navElement.style.height = 'auto';

            if (body.classList.contains('open')) {
            // If accordion content is open, close it with a smooth transition
              slideUp(body);
            } else {
            // If accordion content is closed, open it with a smooth transition
              slideDown(body);
            }
          }
        } else {
          const parentNavElement = document.querySelector('.parent-nav');

          if (parentNavElement){
            parentNavElement.classList.remove('open');
          }
          if (body) {
            // Add active class to the clicked accordion item
            event.preventDefault();
            item.classList.toggle('is-open');
          }
          // Close accordion body when clicking outside
          document.addEventListener('click', event => {
            const isClickInsideAccordion = item.contains(event.target);
            if (!isClickInsideAccordion) {
              item.classList.remove('is-open');
            }
          });
        }
      });
    });

    function slideDown(element) {
      element.style.height = 'auto';
      const height = element.scrollHeight;
      element.style.height = '0';

      setTimeout(() => {
        element.style.height = `${height  }px`;
        element.classList.add('open');
      }, 0);
    }

    function slideUp(element) {
      const height = element.scrollHeight;

      element.style.height = `${height  }px`;

      setTimeout(() => {
        element.style.height = '0';
        element.classList.remove('open');
      }, 0);
    }
  }

}



// WEBPACK FOOTER //
// ./src/ktu/js/components/PrimaryNav.js